import { tranformFormula } from 'src/components/pages/sales/business-rule/helper/transformFormula'
import {
  AIR,
  HOTEL,
  PAYMENT_METHOD,
  INSTALLMENT_METHOD,
  CAR,
  PAYMENT_CHARGE,
  LIQUIDATION,
  BILLING,
  OTHER,
  TRAIN_SEGMENT,
  PRICE,
  TRAIN,
  CONTENT,
  SETTING,
  TRAIN_PASSES,
} from 'src/components/pages/sales/business-rule/helper/const'

// const transformCards = (cards, paymentMethodsCard) => {
//   return cards.map((card) => {
//     let [methodId, cardId] = card.split('_')
//     cardId = parseInt(cardId)
//     return {
//       methodId: parseInt(methodId),
//       id: cardId,
//       name: paymentMethodsCard.find((elem) => elem.id === cardId)?.long_name || '',
//     }
//   })
// }

interface Formula {
  structure: string
  data: Record<string, unknown>
}

interface Air {
  source_relation?: string
  destination?: { exclude: null; include: string[] }
  airline_code?: string
  route?: string
  supplier?: string
  is_emd?: boolean
  gds?: string
}

interface Payment_charge {
  payment_type?: { exclude: null | string[]; include: null | string[] }
  card?: any
  bank?: any
  payment_method?: any
  list_bank?: any
  list_payment_method?: any
}

interface Hotel {
  parameters?: Record<string, unknown>
  supplier?: string
  city?: number[]
  country?: string
  source_relation?: string
}

interface Car {
  renter?: { exclude: null; include: string[] }
  destination?: any // { exclude: null; include: string[] }
}

interface Other {
  supplier?: { exclude: null; include: string[] }
}

interface Setting {
  region: string
  supplier: string[]
  date_in_from: Date
  date_in_to: Date
}

interface Content {
  marketing_carrier: string
  supplier: string[]
}

interface Train_segment {
  supplier?: string[]
  setting?: Setting[]
  content?: Content[]
  marketing_carrier?: { exclude: null; include: string[] }
}

interface PaymentGateway {
  // Define properties for the PaymentGateway object
}

interface obj {
  formulas: any
  jsonParse?: any
  selectedProduct: [
    {
      ref_table: string
    }
  ]
  selectedRuleType: any
  paymentTypes: {
    id: any
    long_name: string
  }[]
  work_unit_token?: any
  objectBank?: any
  objectCard?: any
  checkedBox?: any
  hash_products?: string[]
}

interface data {
  name: string
  is_active: boolean
  json_billing: object
  description: string
  rule_date_start?: string | null | undefined
  rule_date_end?: string | null | undefined
  formula: Formula
  request: Record<string, unknown>
  ref_table_detail: string
  hash_product: string[]
  destination_type_id: number
  rule_type_id: number
  work_unit_token: string
  business_unit_token: string[]
  product_id?: string[]
  parent_rule: any
  priority: number
  reservation_date_from: string
  reservation_date_to: string
  date_in_from: string
  date_in_to: string
  air?: Air
  hotel?: Hotel
  payment?: any
  rule_liquidation_type?: string[]
  payment_charge?: Payment_charge
  car?: Car
  other?: Other
  payment_gateway?: PaymentGateway
  jsonParse?: Record<string, unknown>
  selectedProduct?: [{ ref_table: string }]
  product_token: string[]
  train_segment?: Train_segment
  is_berlin?: boolean
  content?: any
  base_to_billing?: string
  formula_global_variables?: number[]
}

export const transform = (data: data, obj: obj, transformData: any) => {
  const refTable =
    obj.selectedProduct?.[0]?.ref_table === TRAIN_PASSES ? TRAIN_SEGMENT : obj.selectedProduct?.[0]?.ref_table
  const body: data = {
    rule_date_start: data?.rule_date_start,
    rule_date_end: data?.rule_date_end,
    product_token: data.product_id!,
    formula: {
      structure: tranformFormula(obj.formulas),
      data: transformData(obj.jsonParse ? obj.jsonParse : {}, obj.checkedBox),
    },
    date_in_from: data.date_in_from,
    date_in_to: data.date_in_to,
    reservation_date_from: data.reservation_date_from,
    reservation_date_to: data.reservation_date_to,
    request: obj.jsonParse ? obj.jsonParse : {},
    ref_table_detail: `${refTable}_rule_detail`,
    hash_product: obj?.hash_products!,
    work_unit_token: obj.work_unit_token ? obj.work_unit_token : data.work_unit_token,
    name: data.name,
    is_active: data.is_active,
    description: data.description,
    destination_type_id: data.destination_type_id,
    rule_type_id: data.rule_type_id,
    business_unit_token:  data.business_unit_token,
    parent_rule: data.parent_rule ? data.parent_rule?.id : null,
    priority: data.priority,
    json_billing: data.json_billing,
    is_berlin: obj.selectedRuleType === BILLING ? data.is_berlin : false,
    base_to_billing: (obj.selectedRuleType === BILLING || obj.selectedRuleType === LIQUIDATION) ? data.base_to_billing : undefined,
    formula_global_variables: data?.formula_global_variables,
  }
  if (obj.selectedProduct?.[0]?.ref_table === AIR) {
    body.air = {
      source_relation: data.air?.source_relation,
      // destination: data.air.destination,
      destination: { exclude: null, include: ['all'] },
      airline_code: data.air?.airline_code,
      route: data.air?.route,
      supplier: data.air?.supplier,
      gds:data.air?.gds,
      is_emd: data.air?.is_emd,
    }
  }
  if (obj.selectedProduct?.[0]?.ref_table === HOTEL) {
    body.hotel = {
      parameters: {},
      supplier: data.hotel?.supplier,
      city: data.hotel?.country && data.hotel?.country.length > 0 ? data.hotel?.city : [],
      country: data.hotel?.country,
      source_relation: data.hotel?.source_relation,
    }
  }
  if (obj.selectedProduct?.[0]?.ref_table === CAR) {
    body.car = {
      renter: data?.car?.renter,
      destination: data?.car?.destination,
    }
  }
  if (obj.selectedProduct?.[0]?.ref_table === OTHER) {
    body.other = {
      supplier: data?.other?.supplier,
    }
  }
  if (
    obj.selectedProduct?.[0]?.ref_table === TRAIN_SEGMENT ||
    obj.selectedProduct?.[0]?.ref_table === TRAIN_PASSES
  ) {
    if (
      obj.selectedRuleType === LIQUIDATION ||
      obj.selectedRuleType === PRICE ||
      obj.selectedRuleType === BILLING
    ) {
      body.train_segment = {
        supplier: data?.train_segment?.supplier,
        marketing_carrier: data?.train_segment?.marketing_carrier,
      }
    }
    if (obj.selectedRuleType === SETTING) {
      body.train_segment = {
        setting: data?.train_segment?.setting,
      }
    }
    if (obj.selectedRuleType === CONTENT) {
      body.train_segment = {
        content: data?.train_segment?.content,
      }
    }
  }

  if (obj.selectedRuleType === PAYMENT_METHOD) {
    // const cards = transformCards(data.payment.payment_method_card)
    let payment_types_selected_obj = obj.paymentTypes.filter((item) =>
      data.payment.payment_type_id.includes(item.id)
    )
    let payment = payment_types_selected_obj?.map((pay) => ({
      id: pay.id,
      name: pay.long_name || '',
      payment_method: null,
    }))
    body.payment = payment
    // [
    //   {
    //     id: data.payment.payment_type_id,
    //     name: obj.paymentTypes.find((elem) => elem.id === data.payment.payment_type_id)?.long_name || '',
    //     payment_method: null,
    //     // payment_method: data.payment.payment_method_bank.map((elem) => ({
    //     //   id: elem,
    //     //   name: paymentMethodsBank.find((paymentMethod) => paymentMethod.id === elem)?.long_name || '',
    //     //   cards: cards
    //     //     .filter((card) => card.methodId === elem)
    //     //     .map((card) => ({
    //     //       id: card.id,
    //     //       name: card.name,
    //     //     })),
    //     // })),
    //   },
    // ]
  }
  if (obj.selectedRuleType === INSTALLMENT_METHOD) {
    body.payment_gateway = data.payment_gateway
  }
  if (obj.selectedRuleType === LIQUIDATION) {
    body.rule_liquidation_type = data.rule_liquidation_type
  }
  if (obj.selectedRuleType === PAYMENT_CHARGE) {
    let bank = null
    let payment_method = null
    let card = null
    if (data.payment_charge?.payment_type?.include?.includes('CARD')) {
      payment_method = data.payment_charge?.list_payment_method?.find(
        (elem: any) => elem.id === data.payment_charge?.payment_method
      )
      card = payment_method?.cards.find((elem: any) => elem.id === data.payment_charge?.card)
    }
    if (
      data.payment_charge?.payment_type?.include?.includes('TRANSFER') ||
      data.payment_charge?.payment_type?.include?.includes('DEPOSIT')
    ) {
      if (data.payment_charge?.bank?.include?.includes('all')) {
        bank = {
          include: [
            {
              short_name: 'all',
              long_name: 'all',
              id: 99999,
            },
          ],
        }
      } else {
        bank = {}
        Object.entries(data.payment_charge?.bank).forEach((entry: any) => {
          const [key, value] = entry
          bank[key] = value
            .map((elem: any) => {
              const bank = data.payment_charge?.list_bank?.find((bankAux: any) => bankAux.id === elem)
              if (bank) {
                return {
                  short_name: bank?.code,
                  long_name: bank?.name,
                  id: bank?.id,
                }
              }

              return null
            })
            .filter((elem: any) => elem)
        })
      }
    }

    body.payment_charge = {
      payment_type: data.payment_charge?.payment_type,
      payment_method: payment_method,
      bank: bank,
      card: card,
    }
  }

  if (obj.selectedRuleType === CONTENT) {
    body.content = data.content
  }
  return body
}
